<template>
  <div class="csv-import-treatments">
    <login-for-management v-slot="{ clinics }">
      <base-csv-import
        v-slot="{ uploadCsv }"
        titleText="診療項目インポート"
        url="/csv-import-treatments"
        :clinics="clinics"
        :initialCsvData="makeInitialCsvData()"
        :makeConfirmText="makeConfirmText"
      >
        <div>大分類</div>
        <input
          type="file"
          @change="uploadCsv($event, 'treatmentLargeClasses')"
        />
        <div>分類</div>
        <input type="file" @change="uploadCsv($event, 'treatmentClasses')" />
        <div>診療項目</div>
        <input type="file" @change="uploadCsv($event, 'treatments')" />
      </base-csv-import>
    </login-for-management>
  </div>
</template>

<script>
import BaseCsvImport from '@/components/pages/BaseCsvImport'
import LoginForManagement from '@/components/pages/LoginForManagement'
export default {
  name: 'CsvImportTreatments',

  components: {
    BaseCsvImport,
    LoginForManagement
  },

  methods: {
    makeInitialCsvData() {
      return {
        treatmentLargeClasses: null,
        treatmentClasses: null,
        treatments: null
      }
    },
    makeConfirmText(targetClinic) {
      return `「${targetClinic.name}」の診療項目データについて、\n既存の項目を削除し、インポートを行います。実行しますか？`
    }
  }
}
</script>

<style lang="scss" scoped></style>
